import React from 'react'
import styled from 'styled-components'
import { media } from 'app/assets/styles'
import type { QuestionShortDTO } from 'shared/types'
import { QuestionCard } from './QuestionCard'
import { useDispatch, useSelector } from 'react-redux'
import { eventMetadata } from 'shared/store/metadata'
import { colors } from '../../../app-v2/design-systems'
import { SPACING } from '../../../app-v2/design-tokens'
import { DropdownSelect } from '../../common/dropdown'
import { applySelectedCategory } from 'shared/store/faq'

export const QuestionCards = () => {
    const { questions, categories, selectedCategory } = useSelector(
        state => state.faqPageState
    )
    const dispatch = useDispatch()

    const questionWithNoCategoryExist = questions
        ? questions.some(question => question.categories.length === 0)
        : true
    //If some question linked to no category exist, we always display all questions and hide the dropdown filter
    //THis is a temporary solution because there is a bug in the backend making some questions not linked to any category
    const sortedQuestions = questionWithNoCategoryExist
        ? questions
        : questions.filter(question =>
              question.categories.includes(selectedCategory)
          )

    const sendMeta = meta => {
        dispatch(eventMetadata(meta))
    }

    const mapCategoryToSelectOptions = () =>
        categories.map(category => {
            return {
                code: category.code,
                label: category.name
            }
        })

    const handleSelectCategory = (value: string) => {
        dispatch(applySelectedCategory(value))
    }

    return (
        <StyledMainContainer>
            {!questionWithNoCategoryExist && (
                <DropdownSelect
                    selectOptions={mapCategoryToSelectOptions()}
                    color={colors.bbqBrown}
                    borderColor={colors.lightGrey}
                    defaultValue={selectedCategory ? selectedCategory : '-1'}
                    handleChange={handleSelectCategory}
                    placeholderKey="faq.category.placeholder"
                />
            )}
            <StyledQuestionsCardsContainer>
                <StyledQuestionsContainer>
                    {sortedQuestions &&
                        sortedQuestions.map(
                            (question: QuestionShortDTO, index: number) => (
                                <QuestionCard
                                    key={index}
                                    question={question}
                                    sendMeta={sendMeta}
                                />
                            )
                        )}
                </StyledQuestionsContainer>
            </StyledQuestionsCardsContainer>
        </StyledMainContainer>
    )
}

const StyledMainContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${SPACING.M};
`

const StyledQuestionsCardsContainer = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    width: 100%;
`
const StyledQuestionsContainer = styled.div`
    column-count: 1;
    column-gap: 20px;
    ${media.medium`
        column-count: 2;
    `};
`
